import CargoCompanyOrderBillingsDownloadResponse from "../../../../api/raily/cargo-company/order-billings/download/cargo-company-order-billings-download.response";
import CargoCompanyOrderBillingsDownload from "./cargo-company-order-billings-download";

const create = (
  response: CargoCompanyOrderBillingsDownloadResponse,
): CargoCompanyOrderBillingsDownload => {
  const data = response.data;

  return {
    data: data.data,
    filename: data.filename,
  };
};

const cargoCompanyOrderBillingsDownloadFactory = {
  create,
};

export default cargoCompanyOrderBillingsDownloadFactory;
